export default __webpack_public_path__ + "static/media/arrowForwardHelpHighlight@2x.f7b9a14a.png";